import { FC, ReactNode } from 'react';
import {
  MarqueeContainer, MarqueeContent, MarqueeText, TooltipContainer, TooltipText, TooltipWrapper,
} from './styled';

interface TooltipProps {
  text: string;
  children: ReactNode;
  maxChart: number;
  width?: string;
}

const Tooltip: FC<TooltipProps> = ({
  text, children, maxChart, width,
}) => (
  <TooltipContainer>
    <TooltipWrapper>
      {children}
      {text.length > maxChart && (
        <TooltipText width={width}>
          <MarqueeContainer>
            <MarqueeContent contentWidth>
              <MarqueeText>{text}</MarqueeText>
              <MarqueeText>{text}</MarqueeText>
            </MarqueeContent>
          </MarqueeContainer>
        </TooltipText>
      )}
    </TooltipWrapper>
  </TooltipContainer>
);

export default Tooltip;
